import React from "react";
import { PROCESS_PHASES } from "../../data/site";
import { ChevronRight } from "lucide-react";

export default function ProcessTimeline({ SectionHeader }) {
  return (
    <section id="process" className="relative py-24 md:py-32 px-6 md:px-10 border-t border-slate-800/50">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          index="06"
          kicker="Engagement Model"
          title="Five phases. Documented handoffs."
          description="We do not begin any wave without a signed target architecture and a rollback posture. The following methodology has run against forty-seven waves across multiple contract vehicles."
        />

        <div className="relative reveal">
          <div className="hidden md:block absolute left-0 right-0 top-[52px] h-px bg-slate-800" />
          <div className="grid md:grid-cols-5 gap-6 md:gap-4">
            {PROCESS_PHASES.map((p, i) => (
              <div key={p.phase} className="relative">
                <div className="flex items-center gap-3 mb-5">
                  <div className="relative z-10 w-10 h-10 border border-cyan-400/60 bg-slate-950 flex items-center justify-center">
                    <span className="font-mono text-[11px] text-cyan-400 tracking-wider">{p.phase}</span>
                  </div>
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500">{p.code}</div>
                </div>
                <div className="panel p-5 hover-lift h-full">
                  <div className="text-base font-semibold text-slate-100 tracking-tight mb-1">{p.title}</div>
                  <div className="font-mono text-[10px] tracking-widest uppercase text-cyan-300/80 mb-4">{p.duration}</div>
                  <ul className="space-y-2">
                    {p.deliverables.map((d) => (
                      <li key={d} className="flex items-start gap-2 text-xs text-slate-400 leading-relaxed">
                        <ChevronRight size={12} strokeWidth={2} className="text-cyan-400/80 mt-0.5 shrink-0" />
                        <span>{d}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
